<template>
    <!-- 导航 -->
    <NavBar :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'">
        <template v-slot:title>
            <span class="nav-title">市场</span>
        </template>
    </NavBar>
    <!-- 切换/搜索 -->
    <div class="centerSeart">
        <div class="tabBox">
            <div class="list">
                <span class="item" :class="{active: ! selectedCategory}" @click="selectCategory(0)">全部</span>
                <span class="item" :class="{active: selectedCategory == category.id}" v-for="category in categories" :key="category.id" @click="selectCategory(category.id)">
                    {{ category.name }}
                </span>
            </div>
        </div>
    </div>

  <div class="state-box">
    <div class="tag-box">
        <div class="item" :class="{active: state == ''}" @click="selectState('')">全部</div>
        <div class="item" :class="{active: state == states.waiting}" @click="selectState(states.waiting)">预发售</div>
        <div class="item" :class="{active: state == states.normal}" @click="selectState(states.normal)">已发售</div>
        <div class="item" :class="{active: state == states.sellout}" @click="selectState(states.sellout)">已抢光</div>
    </div>
    <div class="colorBoxRight" v-if="false">
      <img src="@/assets/images/right.png" alt="" />
    </div>
    <ul class="select-box" v-if="false">
      <li class="li-text">起售时间从远到近</li>
      <li class="li-text">起售时间从近到远</li>
      <li class="li-text active">关注量从多到少</li>
      <li class="li-text">关注量从少到多</li>
      <li class="li-text">价格从高到低</li>
      <li class="li-text">价格从低到高</li>
    </ul>
  </div>

  <div class="product">
    <div class="maonry">
      <div class="item" v-for="product in products" :key="product.id">
        <router-link :to="'/product/' + product.id">
          <div class="box">
            <van-image class="imgBox" :src="product.cover" fit="cover"></van-image>
            <section class="bottom-box">
              <p class="title">{{ product.name }}</p>
              <p class="creater-box">
                <img class="img-item" :src="product.organization.logo" alt="">
                <section class="issuer">
                    <p class="describe">{{ product.organization.name }}</p>
                </section>
              </p>
              <div class="footBox">
                <p class="fee">
                    <span class="icon">¥</span>{{ product.price }}
                </p>
                <p class="quantity">
                    限量<span class="c-blue"> {{ product.total }} </span>件
                </p>
              </div>
            </section>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>